import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NotificationType } from 'src/app/enum/notification-type.enum';
import { RntFeedModel } from 'src/app/models/commission/rnt-feed.model';
import { CustomHttpRespone } from 'src/app/models/customhttpresponse/custom-http-response';
import { CommissionService } from 'src/app/service/commission.service';
import { KomFeedService } from 'src/app/service/komfeed.service';
import { NotificationService } from 'src/app/service/notification.service';

@Component({
  selector: 'app-edit-rntfeed',
  templateUrl: './edit-rntfeed.component.html',
  styleUrls: ['./edit-rntfeed.component.css']
})
export class EditRntfeedComponent implements OnInit {
  public rntFeedModel = new RntFeedModel();
  public header = 'Update Retention Record';

  constructor(
    private komFeedService: KomFeedService,
    private commissionService: CommissionService,
    private notificationService: NotificationService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.rntFeedModel = this.commissionService.editRntFeedModel || new RntFeedModel();
    if (!this.rntFeedModel?.ret_id) {
      this.notificationService.sendNotification(NotificationType.WARNING, 'No retention record selected');
      this.router.navigate(['/rnt-results']);
    }
  }

  update() {
    const user = localStorage.getItem('CURRENT_USER_NAME_SESSION');
    this.rntFeedModel.last_modified_by = user;
    this.rntFeedModel.updated_by = user;
    this.komFeedService.updateRntFeedByID(this.rntFeedModel).subscribe(
      (response: CustomHttpRespone) => {
        this.notificationService.sendNotification(NotificationType.SUCCESS, response.message);
      },
      (error: HttpErrorResponse) => {
        this.notificationService.sendNotification(
          NotificationType.ERROR,
          error?.error?.message || 'Update failed'
        );
      }
    );
  }

  back() {
    this.router.navigate(['/rnt-results']);
  }
}
